<template>
  <va-edit-layout>
    <action-form :id="id" :title="title" :item="item"></action-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"]
};
</script>
